export default "__VITE_ASSET__c9f77c05__"